export default "__VITE_ASSET__dac815ae__"